import '../../styles/logos.css';
import tool1 from '../../images/tool1.svg';
import tool2 from '../../images/tool2.svg';
import tool3 from '../../images/tool3.svg';
import tool4 from '../../images/tool4.svg';
import tool5 from '../../images/tool5.svg';
import tool6 from '../../images/tool6.svg';
import tool7 from '../../images/tool7.svg';
import tool8 from '../../images/tool8.svg';

export default function Habilites() {
    return (
        <div className="Container Container-Logo">
            <div className="Logos">
                <div class="Logos-slide">
                    <img src={tool1} />
                    <img src={tool2} />
                    <img src={tool3} />
                    <img src={tool4} />
                    <img src={tool5} />
                    <img src={tool6} />
                    <img src={tool7} />
                    <img src={tool8} />
                </div>

                <div class="Logos-slide">
                    <img src={tool1} />
                    <img src={tool2} />
                    <img src={tool3} />
                    <img src={tool4} />
                    <img src={tool5} />
                    <img src={tool6} />
                    <img src={tool7} />
                    <img src={tool8} />
                </div>

                <div class="Logos-slide">
                    <img src={tool1} />
                    <img src={tool2} />
                    <img src={tool3} />
                    <img src={tool4} />
                    <img src={tool5} />
                    <img src={tool6} />
                    <img src={tool7} />
                    <img src={tool8} />
                </div>
                <div class="Logos-slide">
                    <img src={tool1} />
                    <img src={tool2} />
                    <img src={tool3} />
                    <img src={tool4} />
                    <img src={tool5} />
                    <img src={tool6} />
                    <img src={tool7} />
                    <img src={tool8} />
                </div>
            </div>
        </div>
    );
}
